//=====================================================
//　患者情報
//=====================================================
import { AxiosResponse } from "axios";
import { getApiDataWithToken } from "./CallApi";
import { useState } from "react";
import { IFUseAuth } from "./UseAuth";
import { ConstMsg } from "../utils/ConstMsg";

//患者情報IF
export interface IFDataPatientInfo {
    message: string,
    patientId: string,
    firstName: string,
    lastName: string,
    lastVisitDate: string,
    hasCancelWithoutPermission: boolean,
    reFirstVisitEnable: boolean,
    emailRequired: boolean
}

//患者情報初期値定数
export const InitDataPatientInfo:IFDataPatientInfo = {
    message: "",
    patientId: "",
    firstName: "",
    lastName: "",
    lastVisitDate: "",
    hasCancelWithoutPermission: false,
    reFirstVisitEnable: false,
    emailRequired: false
}

//患者情報管理IF
export interface IFUsePatientInfo {
    data: IFDataPatientInfo,
    getData: (clinicId: string, patientNo: string | null) => string,
    update: (val: IFDataPatientInfo, createData?: IFDataPatientInfo) => void,
    clear : ()=>void
}

//-----------------------------------------------------
//　患者情報管理
//-----------------------------------------------------
export function usePatientInfo(ua: IFUseAuth):IFUsePatientInfo{

    const [data, setData] = useState<IFDataPatientInfo>(Object.assign({}, InitDataPatientInfo));
    
    //-----------------------------------------------------
    //患者情報取得
    //-----------------------------------------------------    
    function getData(clinicId: string, patientNo: string | null ):string{
        if (!ua.isLoggedIn()){
            //ログインしていない場合、初期化
            setData(Object.assign({}, InitDataPatientInfo));

        } else {
            //ログインしている場合
            let apiUrl = `/auth/c/${clinicId}/patients/${patientNo}`;
            getApiDataWithToken(
                apiUrl,
                {},
                ua.getToken(),
                function(res:AxiosResponse<any>){
                    if (res?.data) {
                        if (res.status === 200) {
                            let newData:IFDataPatientInfo = Object.assign({}, InitDataPatientInfo);
                            //APIから取得した値格納
                            newData.message = res.data.message;
                            newData.patientId = res.data.patientId;
                            newData.firstName = res.data.firstName;
                            newData.lastName = res.data.lastName;
                            newData.lastVisitDate = res.data.lastVisitDate;
                            newData.hasCancelWithoutPermission = res.data.hasCancelWithoutPermission;
                            newData.reFirstVisitEnable = res.data.reFirstVisitEnabled;
                            newData.emailRequired = res.data.emailRequired;
                            setData(newData);
                        } else {
                            return res.data.message;
                        }
                    } else {
                        return ConstMsg.EG9990001;
                    }                
                }
            );
        }
        return "";
    };
    
    //-----------------------------------------------------
    //　更新
    //-----------------------------------------------------
    function update(val: IFDataPatientInfo, createData?: IFDataPatientInfo){

        let newData:IFDataPatientInfo;
        if (createData){
            newData = Object.assign({}, createData);
        } else {
            newData = Object.assign({}, data);
        }
        
        if (val.message){newData.message = val.message};
        if (val.patientId){newData.patientId = val.patientId};
        if (val.firstName){newData.firstName = val.firstName};
        if (val.lastName){newData.lastName = val.lastName};
        if (val.lastVisitDate){newData.lastVisitDate = val.lastVisitDate};
        if (val.hasCancelWithoutPermission){newData.hasCancelWithoutPermission = val.hasCancelWithoutPermission};
        if (val.reFirstVisitEnable){newData.reFirstVisitEnable = val.reFirstVisitEnable};
        if (val.emailRequired){newData.emailRequired = val.emailRequired};
        setData(newData);
    }

    //-----------------------------------------------------
    //　Contextクリア
    //-----------------------------------------------------
    function clear(){
        let newData:IFDataPatientInfo;
        newData = Object.assign({}, data);
        setData(newData);
    }

    return { data, getData, update, clear }

}